var actions = {
	next: "次へ",
	confirm: "確認",
	"continue": "続行"
};
var errors = {
	unknown: "不明なエラーが発生しました",
	contactSupport: "エラーが発生しました。サポートまでお問合せください。",
	tryAgain: "エラーが発生しました。再試行してください。",
	submit: "送信内容にエラーがあります。"
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "{name} でログイン",
	signupWith: "{name} でサインアップ"
};
var alreadyHaveAccount = {
	company: "{company} アカウントを既にお持ちですか？",
	text: "Streamlabs ID を既にお持ちですか？",
	link: "ログイン"
};
var noAccount = {
	text: "アカウントをまだお持ちでない場合",
	link: "サインアップ"
};
var validation = {
	email: {
		invalid: "有効な電子メールアドレスを入力してください"
	},
	password: {
		required: "パスワードが必要です",
		min: "パスワードは 9 文字以上である必要があります",
		number: "パスワードには数字を含める必要があります",
		upper: "パスワードには大文字を含める必要があります",
		special: "パスワードには特殊文字を含める必要があります"
	},
	username: {
		invalid: "名前は 5 文字以上にする必要があります"
	},
	code: {
		minmax: "コードは 6～10 文字にする必要があります"
	}
};
var poweredBy = "Powered by <company>Streamlabs</company>";
var card = {
	"404": {
		title: "会社が見つかりません！",
		desc: "後で再試行するか、サポートまでお問い合わせください。"
	},
	company: {
		logoAlt: "{company} ロゴ"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6 桁の認証コード/8 桁のバックアップコード",
	successText: "成功しました！リダイレクトしています...",
	remember: "このデバイスを 30 日間記憶する"
};
var createTfa = {
	scan: {
		title: "2 要素認証（2FA）を有効化",
		lead: "ご希望の認証アプリを使って、以下でコードをクリック/コピーまたはスキャンします。<app0 />、<app1 /> または <app2 /> などのアプリを使って、コードを安全に保存することをお勧めします。",
		copied: "コピーされました！",
		instructions: "または、このコードを認証アプリに手動で入力します。",
		copy: "コードをコピー",
		proceed: "確認"
	},
	confirm: {
		title: "2 要素認証（2FA）を確認",
		lead: "以下で生成された 2FA コードを送信して、2 要素認証の確認と有効化を行います。",
		label: "2 要素認証コード（6 桁）",
		verify: "コードの確認",
		next: "成功しました！次のステップ"
	},
	save: {
		title: "リカバリコードを保存",
		lead: "2 要素認証にアクセスできなくなった場合に備えて、以下でリカバリコードを保存してください。このモーダルを閉じると、これらのコードは再度利用できません。",
		label: "リカバリコード",
		download: "リカバリコードをダウンロード",
		copied: "コードがコピーされました！",
		finished: "終了"
	}
};
var emailLoginForm = {
	buttonText: "ログイン",
	emailPlaceholder: "電子メール",
	passwordPlaceholder: "パスワード"
};
var emailSignupForm = {
	buttonText: "サインアップ",
	emailPlaceholder: "電子メールを設定",
	passwordPlaceholder: "パスワードを設定",
	usernamePlaceholder: "あなたの名前",
	ageLabel: "生年月日",
	agePlaceholder: "MM/DD/YYYY",
	agreeText: "私は、Streamlabs の<terms>サービス利用規約</terms>および<privacy>個人情報保護方針</privacy>に同意します。",
	agreeError: "Streamlabs の利用規約に同意してください"
};
var ageInput = {
	invalidDate: "有効な誕生日を入力してください",
	futureDate: "生年月日は過去の日付でなければなりません",
	minDate: "{year} 以前の日付は許容されません",
	minAge_one: "Streamlabs を利用するには、{years} 歳以上である必要があります",
	minAge_two: "Streamlabs を利用するには、{years} 歳以上である必要があります",
	minAge_other: "Streamlabs を利用するには、{years} 歳以上である必要があります"
};
var forgotPasswordForm = {
	emailPlaceholder: "電子メール",
	back: "ログインに戻る",
	successText: "成功しました！パスワードリセットコードを送信しました",
	buttonText: "電子メールのリセットリクエスト",
	create: {
		successText: "成功しました！使用を開始するための確認コードが送信されました！",
		buttonText: "確認コードをリクエスト"
	},
	errors: {
		notFound: "この電子メールアドレスのアカウントが見つかりません"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "パスワードを忘れた場合",
	lead: "パスワードをリセットする必要がある場合、以下に電子メールを入力してください。リセット方法が記載された電子メールが届きます。",
	resetTitle: "パスワードをリセット",
	resetLead: "電子メールでコードが届きます。フォームに入力して、パスワードをリセットします。",
	create: {
		title: "パスワードを作成",
		lead: "Streamlabs ID が作成されました！あと 1 ステップで、すべての Streamlabs でログインできるようになります！",
		resetTitle: "パスワードを選択",
		resetLead: "電子メールでコードが届きます。それを使用し、フォームに入力してパスワードを設定してください。"
	},
	successText: "成功しました！リダイレクトしています...",
	signInTitle: "アカウントを既にお持ちですか？",
	signInBtn: "ログイン"
};
var checkTfaCard = {
	title: "2 要素認証の確認",
	lead: "以下に 2 要素認証コードを入力して続行してください。",
	successText: "2FA が確認されました！",
	back: "戻る"
};
var verifyEmailCard = {
	title: "電子メールを確認",
	lead: "Streamlabs からの 8 桁のコードが記載された電子メールを確認して、以下に入力してください。",
	back: "戻る",
	successText: "電子メールが確認されました！"
};
var upgradeCard = {
	confirm: {
		title: "{company}接続を確認",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"続行すると、提供した電子メールとパスワードを使って、{company} にログインできるようになります。",
			"ID を使って Streamlabs からその他の全ての製品にもアクセスしたり、その他の既存のアカウント（お持ちの場合）を接続したりすることもできます。",
			"あなたの {company} アカウントは、この変更の影響を受けません。"
		],
		button: "確認",
		cancel: "キャンセル",
		switchAccount: "アカウントの切り替え",
		success: "接続しています..."
	},
	confirmed: {
		title: "成功しました！",
		subtitle: "Streamlabs ID が作成され、{company} アカウントが接続されました。",
		text: "Streamlabs の全製品に対して、Streamlabs ID を使うことができます。既存のアカウントをお持ちの場合、そのアカウントを各アプリからこの ID に接続することができます。",
		button: "閉じる"
	},
	error: {
		user: "ユーザーを識別できませんでした。ログインを再試行するか、サポートまでお問い合わせください。"
	}
};
var confirmCard = {
	confirm: {
		title: "{company} 接続を確認",
		subtitle: "電子メールが一致するアカウントが見つかりました。このアカウントを Streamlabs ID と結合しますか？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID を通して提供された電子メールとパスワードで、{company} にログインできます。",
			"ID を使って Streamlabs からその他の全ての製品にもアクセスしたり、その他の既存のアカウント（お持ちの場合）を接続したりすることもできます。",
			"あなたの会社アカウントは、この変更の影響を受けません。"
		],
		button: "確認",
		cancel: "キャンセル",
		switchAccount: "アカウントの切り替え",
		success: "接続しています..."
	},
	confirmed: {
		title: "成功しました！",
		subtitle: "Streamlabs ID が作成され、{company} アカウントが接続されました。",
		text: "Streamlabs の全製品に対して、Streamlabs ID を使うことができます。既存のアカウントをお持ちの場合、そのアカウントを各アプリからこの ID に接続することができます。",
		button: "閉じる"
	},
	error: {
		user: "ユーザーを識別できませんでした。ログインを再試行するか、サポートまでお問い合わせください。"
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " ID には {company} アカウントが既に接続されています",
		subtitle: "接続されたアカウントのリンクを解除して、現在の Streamlabs アカウントにリンクしますか？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID に対して提供した電子メールとパスワードで、Streamlabs にログインできます。",
			"ID を使って Streamlabs からその他の全ての製品にもアクセスしたり、その他の既存のアカウント（お持ちの場合）を接続したりすることもできます。",
			"あなたの Streamlabs アカウントは、この変更の影響を受けません。"
		],
		button: "確認",
		cancel: "キャンセル",
		switchAccount: "アカウントの切り替え",
		success: "接続しています...",
		agreeLabel: "私は、この接続を確立することで、Streamlabs ID に結合された既存の {company} アカウントへのアクセスが失われることを理解しました。"
	},
	confirmed: {
		title: "成功しました！",
		subtitle: "Streamlabs ID が作成され、{company} アカウントが接続されました。",
		text: "Streamlabs の全製品に対して、Streamlabs ID を使うことができます。既存のアカウントをお持ちの場合、そのアカウントを各アプリからこの ID に接続することができます。",
		button: "閉じる"
	},
	error: {
		user: "ユーザーを識別できませんでした。ログインを再試行するか、サポートまでお問い合わせください。"
	}
};
var loginCard = {
	title: "ログイン",
	lead: "<id>Streamlabs ID</id> を使って <company>{company}</company> にログイン",
	accountExists: "<b>Streamlabs ID</b> をお持ちのようです。電子メールを使ってサインインを試みてください。",
	forgotPassword: "パスワードを忘れた場合",
	successText: "成功しました！リダイレクトしています...",
	signInTitle: "プラットフォームでログイン"
};
var loginSourcesCard = {
	title: "ログイン",
	lead: "電子メール/パスワードでログイン",
	withSlId: "Streamlabs ID でログイン",
	noAccountMessage: "このログイン方法に関連付けられたアカウントはありません。別のログイン方法を試すか、まだサインアップしていない場合は<signup>サインアップ</signup>してください。",
	accountExistsMessage: "お客様の Twitch 電子メールアドレスは、既に Streamlabs に関連付けられています。Streamlabs 電子メールとパスワードでサインインを試みてください。"
};
var resetPasswordForm = {
	emailPlaceholder: "電子メール",
	codePlaceholder: "6～8 桁の電子メールコード",
	tfaCodePlaceholder: "2 要素認証コード",
	newPasswordPlaceholder: "新しいパスワード",
	tfaError: "リセットコードは 6～10 文字にする必要があります",
	next: "コードが届きましたか？",
	back: "「パスワードを忘れた場合」に戻る",
	buttonText: "パスワードを変更",
	successText: "パスワードがリセットされました",
	create: {
		back: "最初に戻る",
		buttonText: "パスワードを設定",
		successText: "パスワードが設定されました"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "現在のパスワード",
	newPasswordPlaceholder: "新しいパスワード",
	newPasswordConfirmationPlaceholder: "新しいパスワードを再入力",
	buttonText: "パスワードを変更",
	successText: "パスワードが更新されました",
	newPasswordConfirmationError: "新しいパスワードが一致しません",
	back: "ダッシュボードに戻る"
};
var changePasswordCard = {
	title: "パスワードを変更",
	lead: "以下に、現在のパスワードと新しいパスワードを入力します。",
	successText: "パスワードが更新されました"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6 桁の認証コード/8 桁のバックアップコード",
	successText: "2FA が削除されました",
	removeBtn: "確認 & 削除"
};
var removeTfaCard = {
	title: "2 要素認証を削除",
	lead: "2FA 確認コードを下に入力して、2 要素認証をお使いのアカウントから削除します。",
	successText: "2FA が削除されました",
	back: "ダッシュボードに戻る"
};
var verifyEmailForm = {
	codePlaceholder: "電子メールからの 8 桁のコード",
	tfaCodePlaceholder: "2 要素認証コード",
	emailPlaceholder: "電子メールアドレス",
	buttonText: "電子メールを確認",
	successText: "電子メールが確認されました",
	requestBtn: "新しいコードをリクエスト",
	requestingBtn: "リクエストしています...",
	requestSuccess: "お客様の電子メールにコードが送信されました",
	requestAgain: "{seconds} 秒以内に再度リクエストしてください",
	tfaError: "リセットコードは 6～10 文字にする必要があります",
	back: "戻る"
};
var signupCard = {
	title: "サインアップ",
	lead: "<id>Streamlabs ID</id> アカウントを作成して、<company>{company}</company> を使用します",
	successText: "成功しました！リダイレクトしています..."
};
var signupSourcesCard = {
	title: "サインアップ",
	lead: "<id>Streamlabs ID</id> アカウントを作成して、<company>{company}</company> を使用します",
	withSlId: "Streamlabs ID を作成"
};
var connectCard = {
	connect: {
		title: "アカウントを選択して",
		lead: "<b>{company}</b> で続行",
		authorize: "認証",
		authorizeSuccess: "成功しました！",
		cancel: "キャンセル",
		disclaimer: {
			streamlabs: "続行すると、お客様の Streamlabs ID（名前、電子メールアドレス、言語設定、およびプロファイル画像）が <b>{company}</b> と共有されます。<b>{company}</b> とのアカウントを承認することで、お客様はここに、<b>{company}</b> の<privacy>プライバシー ポリシー</privacy>および<terms>利用規約</terms>に同意したことになります。",
			"default": "続行するには、Streamlabs はお客様の名前、電子メールアドレス、言語設定、およびプロファイル画像を <b>{company}</b> と共有します。<b>{company}</b> とのアカウントを承認することで、お客様はここに、<b>{company}</b> の<privacy>プライバシー ポリシー</privacy>および<terms>利用規約</terms>に同意したことになります。"
		},
		emailRequired: "続行前に、電子メールの確認が必要です",
		tfaRequired: "続行前に、2 要素認証が必要です"
	},
	login: {
		title: "{company} にログイン",
		lead: "ログインしてアカウントに接続する必要があります",
		loginBtn: "ログインに進む"
	},
	error: {
		title: "{company} にログイン",
		lead: "現時点で、リクエストを承認できません。",
		verifyEmail: "電子メールを確認",
		verify2fa: "2FA を確認"
	},
	"switch": {
		btn: "別のアカウントを使用"
	}
};
var appsDropdown = {
	label: "Streamlabs 製品 & アプリ",
	viewMore: "展開",
	viewLess: "折り畳む"
};
var platformButtons = {
	loginWithPlatform: "プラットフォームでログイン",
	signUpWithPlatform: "プラットフォームでサインアップ",
	signUpLead: "当社ではその他多数のプラットフォームへのライブストリームをサポートしています。これらは単にサインアップオプションです。"
};
var ultraCheckoutCard = {
	title: "<b>Streamlabs Ultra でライブストリーム、ブランディング、編集などをレベルアップ</b>",
	badge: "<b>{planName}</b> が含まれています",
	totalValue: "{price, currency} 価格",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>、<b>コンソール</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b>、その他を含む完全スイートのプレミアム機能を利用しましょう。手頃な単一価格で利用できます。",
		year: "<b>Streamlabs Desktop</b>、<b>コンソール</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b>、その他を含む完全スイートのプレミアム機能を利用しましょう。手頃な単一価格で利用できます。"
	},
	seeIncluded: "詳細",
	buyNow: "アップグレード"
};
var ultraCheckoutBanner = {
	title: "<b>Streamlabs Ultra でライブストリーム、ブランディング、編集などをレベルアップ</b>",
	badge: "<b>{planName}</b> が含まれています",
	totalValue: "{price, currency} 価格",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>、<b>コンソール</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b>、その他を含む完全スイートのプレミアム機能を利用しましょう。手頃な単一価格で利用できます。 <link />",
		year: "<b>Streamlabs Desktop</b>、<b>コンソール</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b>、その他を含む完全スイートのプレミアム機能を利用しましょう。手頃な単一価格で利用できます。 <link />"
	},
	seeIncluded: "詳細",
	buyNow: "アップグレード"
};
var connect = {
	waitMessage: "データを結合しています。このウィンドウを閉じないでください。"
};
var verifyPasswordCard = {
	success: "パスワードが認証されました",
	title: "確認のため再認証を行ってください",
	lead: "既存の電子メールとパスワードでログインし、Streamlabs ID の更新を続けてください。",
	buttonText: "次へ"
};
var emailChangeForm = {
	agreeError: "あなたがこのアクションを理解していることを確認してください",
	buttonText: "次へ",
	emailPlaceholder: "新しい電子メールアドレス",
	agreeText: "いったん認証されると、私の Streamlabs ID が接続されているすべての Streamlabs 製品で変更されることを理解しました。"
};
var verifyNewEmailCard = {
	title: "Streamlabs ID を変更する",
	lead: "Streamlabs ID として使用する新しい電子メールを入力してください。このアドレスに 6～8 桁の認証コードが届きます。",
	successText: "新しい電子メールが利用可能です"
};
var verifyNewEmailOwnershipCard = {
	title: "更新された Streamlabs ID を確認する",
	lead: "Streamlabs からの 8 桁のコードが記載された電子メールを確認して、以下に入力してください。",
	buttonText: "確認",
	back: "戻る",
	codePlaceholder: "電子メールからの 8 桁のコード",
	successText: "電子メールの所有者が確認されました"
};
var verifyTfaCard = {
	title: "2 要素認証コード",
	lead: "認証アプリからの 6 桁の認証コードを入力します。",
	codePlaceholder: "6 桁のコード",
	buttonText: "確認",
	successText: "2 要素認証が確認されました",
	back: "戻る"
};
var ageGateForm = {
	ageLabel: "生年月日",
	agePlaceholder: "MM/DD/YYYY"
};
var ageGateCard = {
	title: "アカウントのセットアップを完了",
	lead: {
		years: "アカウントを作成するには、{years} 歳以上である必要があります。<br />生年月日を入力してセットアップを完了してください。",
		noYears: "アカウントを作成するには、生年月日を入力する必要があります。<br />入力してセットアップを完了してください。"
	},
	successText: "おめでとうございます！アカウントのセットアップが完了しました。"
};
var jaJP = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { jaJP as j };
//# sourceMappingURL=ja-JP.es.js.map
